/** Formats a comms timestamp for the item comms message cards and conversation modal. */
export const formatCommsTimestamp = (value: Date | string): string =>
  new Date(value).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
